import { Fetcher } from '@this/src/util';
import _ from 'lodash';
import { observable, computed } from 'mobx';

export interface ExpensesAccountTypeJson {
  id?: number;
  name: string;
  code: string | null;
  selected?: boolean;
  is_deleted?: boolean;
  display_order?: number;
  freee_account_item_id?: string;
  bugyo_account_item_code?: string | null;
  receipt_file_required?: boolean;
}

interface DepartmentstResponse {
  departments: string;
}
export class ExpensesAccountType {
  id?: number;

  @observable name: string;
  @observable code: string | null;
  @observable departments: string;

  selected: boolean;

  isDeleted?: boolean;

  displayOrder?: number | null;

  @observable freeeAccountItemId?: string | null;
  @observable bugyoAccountItemCode?: string | null;

  receiptFileRequired?: boolean;

  private departmentsPath: string;

  constructor(args: ExpensesAccountTypeJson) {
    this.id = args.id;
    this.name = args.name;
    this.code = args.code;
    this.selected = false;
    this.isDeleted = args.is_deleted;
    this.displayOrder = args.display_order;
    this.freeeAccountItemId = args.freee_account_item_id;
    this.bugyoAccountItemCode = args.bugyo_account_item_code;
    this.departments = '';
    this.departmentsPath = `/organization/expenses_account_types/${this.id}/departments`;
    this.receiptFileRequired = args.receipt_file_required;
  }

  @computed
  get codeText() {
    if (this.code?.match(/\S/g)) {
      return `(${this.code})`;
    }
    return '';
  }

  @computed
  get isDeletedName() {
    if (this.isDeleted) {
      return `${this.name}(削除済)`;
    }
    return this.name;
  }

  codeAndNameOneLine = (): string => {
    if (this.code) {
      return `${this.code}:${this.name}`;
    }
    return this.name;
  };

  getIdStr = (): string => {
    return this.id ? this.id.toString() : '';
  };

  submitParams() {
    return {
      id: this.id,
      name: this.name,
      code: this.code,
      departments: this.departments,
      display_order: this.displayOrder,
      freee_account_item_id: this.freeeAccountItemId,
      bugyo_account_item_code: this.bugyoAccountItemCode,
      receipt_file_required: this.receiptFileRequired
    };
  }

  static new() {
    return new ExpensesAccountType({ receipt_file_required: false, name: '', code: '' });
  }

  async fetchDepartments() {
    await Fetcher.get<DepartmentstResponse>(`${this.departmentsPath}.json`).then(
      result => {
        this.departments = result.departments;
      },
      _error => {
        throw _error;
      }
    );
  }

  setReceiptFileRequired(value: boolean) {
    this.receiptFileRequired = value;
    app.render();
  }
}

export default ExpensesAccountType;
